import { getToken, getUserName } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetOnboardingStatus = async (navigate, initialUserId = null) => {
  const accesstoken = getToken();
  const currentUserId = getUserName();
  
  // Check if the userId has changed (different user logged in from another tab)
  if (initialUserId && currentUserId && initialUserId !== currentUserId) {
    console.warn('User identity changed - different user logged in from another tab');
    // Use a user-specific flag to avoid affecting other tabs
    localStorage.setItem(`sessionExpired_${initialUserId}`, 'true');
    navigate(`/login`);
    return;
  }
  
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Account/GetOnboardingStatus`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

      if (!response.ok && data.isError && data.statusCode === "Unauthorized") {
          // Set session expired flag before navigating to login
          const userId = currentUserId || 'unknown';
          localStorage.setItem(`sessionExpired_${userId}`, 'true');
          navigate(`/login`);
      } else {
        return data;
      } 
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    // Set session expired flag before navigating to login
    const userId = currentUserId || initialUserId || 'unknown';
    localStorage.setItem(`sessionExpired_${userId}`, 'true');
    navigate(`/login`);
  }
};

